// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_jlpt_levels_n3_description = /** @type {(inputs: {}) => string} */ () => {
	return `Level up your Japanese! Understand more complex sentences, read everyday materials, and engage in casual conversations.`
};

const id_jlpt_levels_n3_description = /** @type {(inputs: {}) => string} */ () => {
	return `Tingkatkan kemampuan bahasa Jepang Anda! Pahami kalimat yang lebih rumit, baca materi sehari-hari, dan terlibat dalam percakapan santai.`
};

const ja_jlpt_levels_n3_description = /** @type {(inputs: {}) => string} */ () => {
	return `日本語をレベルアップ！より複雑な文章を理解し、日常的な資料を読み、カジュアルな会話を楽しみましょう。`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "id" | "ja" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const jlpt_levels_n3_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.jlpt_levels_n3_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("jlpt_levels_n3_description", locale)
	if (locale === "en") return en_jlpt_levels_n3_description(inputs)
	if (locale === "id") return id_jlpt_levels_n3_description(inputs)
	return ja_jlpt_levels_n3_description(inputs)
};
export { jlpt_levels_n3_description as "jlpt_levels.n3.description" }